import { createStore } from 'vuex';

import studentsModule from './modules/students/index.js';
import schoolModule from './modules/school/index.js';
import subscriptionsModule from './modules/subscriptions/index.js';
import typesDanceModule from './modules/type-dance/index.js';
import packageModule from './modules/package/index.js';
import authModule from './modules/auth/index.js';
import userModule from './modules/user/index.js';
import scheduleModule from './modules/schedule/index.js';
import languageModule from './modules/language/index.js';
import feedbackModule from './modules/feedback/index.js';
import notificationsModule from './modules/notifications/index.js';
import trialModule from './modules/trial/index.js';
import checkinModule from './modules/checkin/index.js';
import schoolProfileModule from './modules/schoolProfile/index.js';
import schoolWaitlistModule from './modules/schoolWaitlist/index.js';
import discoverModule from './modules/discover/index.js';
import directoryModule from './modules/directory/index.js';
import adminDirectoryModule from './modules/adminDirectory/index.js';

const store = createStore({
    modules: {
        students: studentsModule,
        school: schoolModule,
        subscriptions: subscriptionsModule,
        typesDance: typesDanceModule,
        packages: packageModule,
        auth: authModule,
        user: userModule,
        schedule: scheduleModule,
        language: languageModule,
        notifications: notificationsModule,
        feedback: feedbackModule,
        trial: trialModule,
        checkin: checkinModule,
        schoolProfile: schoolProfileModule,
        schoolWaitlist: schoolWaitlistModule,
        discover: discoverModule,
        directory: directoryModule,
        adminDirectory: adminDirectoryModule,
    },
    state() {
        return {
            currencySymbole: '$',
            //TODO: change payment methods to be dynamic from the backend
            paymentMethods: [
                {name: 'Cash', value: 'cash'},
                {name: 'Revolut', value: 'revolut'},
                {name: 'Wise', value: 'wise'},
                {name: 'other', value: 'other'},
            ],
            roles: ['user', 'admin', 'owner', 'student', 'teacher', 'assistant']
        };
    },
    getters: {
        getCurrencySymbole(state) {
            return state.currencySymbole;
        },
        getPaymentMethods(state) {
            return state.paymentMethods;
        }
    },
});

export default store;